import { useEffect, useState } from "react";

const getIsOnline = () => {
  if (typeof navigator === "undefined") {
    return true;
  }
  return navigator.onLine;
};

export const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(getIsOnline);
  const [offlineAt, setOfflineAt] = useState(null);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setOfflineAt(null);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setOfflineAt(new Date());
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return {
    isOnline,
    offlineAt,
  };
};

export default useNetworkStatus;
